import React, { useState } from "react";
import "../assets/styles/header.css";
import SeeingMoneyLogo from "../assets/images/SeeingMoneyLogo.svg";

const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo */}
        <a href="/" className="logo">
          <img src={SeeingMoneyLogo} alt="SeeingMoney Logo" />
          <span>SeeingMoney</span>
        </a>

        {/* Navigation */}
        <nav className={`nav ${isMobileMenuOpen ? "mobile-visible" : ""}`}>
          <ul className="nav-links">
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            {/* Free Tools Dropdown */}
            <li className="dropdown">
              <a href="/free-tools" className="dropdown-link">Free Tools</a>
              <ul className="dropdown-menu">
                <li>
                  <a href="/compound-interest">Compound Interest Calculator</a>
                </li>
                <li>
                  <a href="/financial-independence">Financial Independence Calculator</a>
                </li>
              </ul>
            </li>
            {/* <li><a href="/contact">Contact</a></li> */}
          </ul>
        </nav>

        {/* Instagram CTA */}
        <div className="cta-container">
          <button className="cta-btn">
            <a
              href="https://www.instagram.com/Seeing.Money/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Follow Us on Instagram
            </a>
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="mobile-menu-icon" onClick={toggleMobileMenu}>
          ☰
        </button>
      </div>
    </header>
  );
};

export default Header;
